'use client'

import { usePathname } from 'next/navigation'
import Image from 'next/image'
import Shopmn from '@/assets/logo.svg'
import { getFontClass } from '@/utils/util'
import { navigateUrl } from '@/utils/client-request'
import { getVendorPhones } from '@/utils/vendorPhones'
import { ShieldCheck, ShieldX } from 'lucide-react'
import { useNavigation } from '@/lib/commerce/hooks'

const socialIcons = {
  facebook: (props: React.SVGProps<SVGSVGElement>) => (
    <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
        clipRule="evenodd"
      />
    </svg>
  ),
  instagram: (props: React.SVGProps<SVGSVGElement>) => (
    <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
        clipRule="evenodd"
      />
    </svg>
  ),
  twitter: (props: React.SVGProps<SVGSVGElement>) => (
    <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path d="M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75404L10.7663 14.0113L15.5685 21H20.8131L13.6819 10.6218H13.6823ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.096V13.0956Z" />
    </svg>
  ),
  youtube: (props: React.SVGProps<SVGSVGElement>) => (
    <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z"
        clipRule="evenodd"
      />
    </svg>
  )
}

const focusRing = 'focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-foreground'
const barItem = 'md:relative md:ml-6 md:pl-6 2xl:ml-12 2xl:pl-12 md:before:absolute md:before:left-0 md:before:top-1/2 md:before:h-5 md:before:w-px md:before:-translate-y-1/2 md:before:bg-foreground/40'

type FooterLink = { name: string, href?: string, external?: boolean }

export default function Footer({ vendor, subscription, campaigns }: { vendor?: any, subscription?: any, campaigns?: any }) {
  const pathname = usePathname()
  const phones = getVendorPhones(vendor)
  const fontClass = getFontClass(vendor?.font)
  const { navigation, footer } = useNavigation({ vendor, subscription, campaigns, icons: { loyalty: true } })
  const { info, help, socials, hasInfoSection } = footer
  const socialLinks = socials.map(s => ({ ...s, icon: socialIcons[s.platform] }))

  const contact: FooterLink[] = [
    ...phones.map(p => ({ name: p, href: `tel:${p}`, external: true })),
    ...(vendor?.email ? [{ name: vendor.email, href: `mailto:${vendor.email}`, external: true }] : []),
    ...(vendor?.address ? [{ name: vendor.address }] : []),
  ]

  const columns: { title: string, links: FooterLink[] }[] = [
    { title: 'Дэлгүүр', links: [{ name: 'Бүх бараа', href: '/product' }, ...navigation.links] },
    ...(hasInfoSection ? [{ title: 'Мэдээлэл', links: info }] : []),
    { title: 'Үйлчилгээ', links: help },
    ...(contact.length > 0 ? [{ title: 'Холбоо барих', links: contact }] : []),
  ]

  return (
    <footer className={`${fontClass} mt-24 border-t border-border bg-background text-foreground`}>
      <div className="w-full px-4 lg:px-6 pt-10 lg:pt-12 pb-16 lg:pb-40 grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-10">
        {columns.map(column => (
          <div key={column.title} className="min-w-0">
            <h3 className="text-[13px] uppercase tracking-wide text-foreground/70">{column.title}</h3>
            <ul className="mt-5 space-y-1">
              {column.links.map(link => (
                <li key={link.name}>
                  {link.href ? (
                    <a href={link.external ? link.href : navigateUrl(link.href, pathname)} className={`text-[15px] leading-snug wrap-break-word box-decoration-clone pb-0.5 bg-[linear-gradient(currentColor,currentColor)] bg-no-repeat bg-position-[0_100%] bg-size-[0%_1px] hover:bg-size-[100%_1px] focus-visible:bg-size-[100%_1px] transition-[background-size] duration-500 ease-out motion-reduce:transition-none ${focusRing}`}>{link.name}</a>
                  ) : (
                    <span className="text-[15px] leading-snug">{link.name}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="w-full px-4 lg:px-6 pt-4 pb-28 lg:pb-12 text-[13px]">
        <div className="md:-mx-2 md:px-2 md:overflow-x-clip">
          <div className="flex flex-col md:flex-row md:flex-wrap md:items-center gap-y-5 md:gap-y-4 md:-ml-12 2xl:-ml-24">
            <span className={barItem}>&copy; {new Date().getFullYear()} {vendor?.name || 'Shop.mn'}. Бүх эрх хуулиар хамгаалагдсан.</span>
            {socialLinks.length > 0 && (
              <ul className={`${barItem} flex items-center gap-7`}>
                {socialLinks.map(item => (
                  <li key={item.name}>
                    <a href={item.href} target="_blank" rel="noopener noreferrer" aria-label={item.name} className={`block transition-opacity duration-150 hover:opacity-60 ${focusRing}`}>
                      <item.icon aria-hidden="true" className="size-5" />
                    </a>
                  </li>
                ))}
              </ul>
            )}
            <a href={navigateUrl('/status', pathname)} className={`${barItem} inline-flex items-center gap-1.5 transition-opacity duration-150 hover:opacity-60 ${focusRing}`}>
              {vendor?.isDanVerified ? <ShieldCheck className="size-4 shrink-0" strokeWidth={1.5} /> : <ShieldX className="size-4 shrink-0" strokeWidth={1.5} />}
              {vendor?.isDanVerified ? 'Улсын бүртгэлээр баталгаажсан' : 'Улсын бүртгэлээр баталгаажаагүй'}
            </a>
            <a href="https://shop.mn" target="_blank" rel="noopener noreferrer" className={`md:ml-auto md:pl-12 inline-flex items-center gap-1.5 text-foreground/70 transition-opacity duration-150 hover:opacity-60 ${focusRing}`}>
              Онлайн худалдааны шийдэл
              <Image src={Shopmn} alt="Shop.mn" className="h-3.5 w-auto shrink-0 brightness-0 opacity-70" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
